export default {
  NONE : 0,
  ACTIVE : 1,
  SUSPEND : 2,
  EXPIRED : 3,
}
